var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoUserConnectionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.531,
    height: 96.408,
    viewBox: "0 0 97.531 96.408",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7405",
    "data-name": "Trazado 7405",
    d: "M12.56,11.688,34.174,34.5,61.793,7.485l-34.221-4.2Z",
    transform: "translate(-12.56 -3.283)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1721",
    "data-name": "Rect\\xE1ngulo 1721",
    width: 97.531,
    height: 96.408,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4335",
    "data-name": "Grupo 4335",
    transform: "translate(-723 -463)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4332",
    "data-name": "Grupo 4332"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7400",
    "data-name": "Trazado 7400",
    d: "M36.532,19.719a10.807,10.807,0,1,1-15.284,0A10.807,10.807,0,0,1,36.532,19.719Z",
    transform: "translate(743.369 481.645)",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7401",
    "data-name": "Trazado 7401",
    d: "M12.972,48.9a21.677,21.677,0,0,1,43.354,0",
    transform: "translate(737.611 493.661)",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_4317",
    "data-name": "Grupo 4317",
    transform: "translate(749.707 469.981)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7402",
    "data-name": "Trazado 7402",
    d: "M57.921,29.252A23.114,23.114,0,1,1,34.805,6.137,23.115,23.115,0,0,1,57.921,29.252Z",
    transform: "translate(-13.538 -0.068)",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7403",
    "data-name": "Trazado 7403",
    d: "M46.476,33.4a16.786,16.786,0,1,1-7.523-22.516A16.786,16.786,0,0,1,46.476,33.4Z",
    transform: "translate(-10.188 3.282)",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7404",
    "data-name": "Trazado 7404",
    d: "M38.33,27.815A11.069,11.069,0,1,1,33.37,12.969,11.069,11.069,0,0,1,38.33,27.815Z",
    transform: "translate(-7.158 6.311)",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoUserConnectionWhite);
export default __webpack_public_path__ + "static/media/logo-user-connection-white.d8af687c3fb3162394b5413658d1b219.svg";
export { ForwardRef as ReactComponent };